'use client'

import Script from 'next/script'

const SCRIPT_LIST = [
	{
		id: 'facebook-jssdk',
		src: '//connect.facebook.net/ko_KR/sdk.js#xfbml=1&amp;version=v2.6&amp;appId=121321984616003',
	},
	{
		id: 'twitter-widgets',
		src: 'https://platform.twitter.com/widgets.js',
	},
	{
		id: 'facebook-sdk',
		src: 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v11.0',
	},
	{
		id: 'instagram-EmbedSDK',
		src: 'https://instagram.com/static/bundles/es6/EmbedSDK.js/47c7ec92d91e.js',
	},
	{
		id: 'highcharts-new',
		src: 'https://fs.jtbc.co.kr/i-jam/js/jam/lib/highcharts-new/highcharts.js',
	},
	{
		id: 'highcharts-new-3d',
		src: 'https://fs.jtbc.co.kr/i-jam/js/jam/lib/highcharts-new/highcharts-3d.js',
	},
	{
		id: 'highcharts-new-more',
		src: 'https://fs.jtbc.co.kr/i-jam/js/jam/lib/highcharts-new/highcharts-more.js',
	},
	{
		id: 'highcharts-new-map',
		src: 'https://fs.jtbc.co.kr/i-jam/js/jam/lib/highcharts-new/map.js',
	},
	{
		id: 'highcharts-new-world',
		src: 'https://fs.jtbc.co.kr/i-jam/js/jam/lib/highcharts-new/world.js',
	},
	{
		id: 'highcharts-new-exporting',
		src: 'https://fs.jtbc.co.kr/i-jam/js/jam/lib/highcharts-new/exporting.js',
	},
]

const ScriptLib = () => {
	const handlerOnReady = () => {
		console.log('handlerOnReady')
	}
	const handlerOnError = (event: Error) => {
		console.log('handlerOnError', event)
	}
	const scriptLoader = (item: { id: string; src: string }) => (
		<Script
			defer
			key={item.id}
			id={item.id}
			src={item.src}
			type="text/javascript"
			onReady={handlerOnReady}
			onError={(e: Error) => {
				handlerOnError(e)
			}}
		/>
	)
	return <>{SCRIPT_LIST.map(scriptLoader)}</>
}

export default ScriptLib
